var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "next",
  transform: "translate(15 28.396) rotate(180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M14.769,13.632,1.373.237A.8.8,0,0,0,.237,1.373L13.061,14.2.237,27.022a.8.8,0,0,0,0,1.137A.809.809,0,0,0,.8,28.4a.784.784,0,0,0,.565-.238l13.4-13.4A.8.8,0,0,0,14.769,13.632Z",
  transform: "translate(0 0)",
  fill: "#314550"
}));
function SvgNavLeftBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 28.396,
    viewBox: "0 0 15 28.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLeftBlack);
export default __webpack_public_path__ + "static/media/navLeftBlack.b95db52f0da7a8691165e880a79ae358.svg";
export { ForwardRef as ReactComponent };